<template>
  <v-dialog
    v-model="computedPatrolPermanentpostsVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('patrol', 'permanentposts', false);
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedSignline }} #{{ computedPostnum }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- delete/edit icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            v-if="disable_edit"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn
            v-else
            color="primary"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="disable_edit = !disable_edit"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedPatrolPermanentpostsGeoJsonFeature"
          :loading="computedPatrolPermanentpostsLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>Mountain</td>
              <td>{{ props.item.properties.mountain }}</td>
            </tr>
            <tr>
              <td>Zone</td>
              <td>{{ props.item.properties.zone }}</td>
            </tr>
            <tr>
              <td>Sign Line</td>
              <td>{{ props.item.properties.sign_line }}</td>
            </tr>
            <tr>
              <td>Post Number</td>
              <td>
                <v-text-field
                  ref="permanentposts_postnum"
                  v-model="props.item.properties.post_num"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Condition</td>
              <td>
                <v-select
                  :items="opt_condition"
                  ref="permanentposts_condition"
                  v-model="props.item.properties.condition"
                  :label="props.item.properties.condition"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Purpose</td>
              <td>
                <v-select
                  :items="opt_purpose"
                  ref="permanentposts_purpose"
                  v-model="props.item.properties.purpose"
                  :label="props.item.properties.purpose"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Sign</td>
              <td>
                <v-select
                  :items="opt_sign"
                  ref="permanentposts_sign"
                  v-model="props.item.properties.sign"
                  :label="props.item.properties.sign"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Sign Type</td>
              <td>
                <v-text-field
                  ref="permanentposts_signtype"
                  v-model="props.item.properties.sign_type"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Rope</td>
              <td>
                <v-select
                  :items="opt_rope"
                  ref="permanentposts_rope"
                  v-model="props.item.properties.rope"
                  :label="props.item.properties.rope"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Source</td>
              <td>
                <v-select
                  :items="opt_source"
                  ref="permanentposts_source"
                  v-model="props.item.properties.source"
                  :label="props.item.properties.source"
                  :disabled="disable_edit"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Coordinates</td>
              <td>
                {{
                  props.item.geometry.coordinates[0] +
                    ", " +
                    props.item.geometry.coordinates[1]
                }}
              </td>
            </tr>
            <tr>
              <td>Last Edited</td>
              <td>
                <span v-if="disable_edit">
                  {{ props.item.properties.edit_by }}
                </span>
                <span v-if="!disable_edit">
                  {{ computedAuth.profile.email }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Modified</td>
              <td>
                <span v-if="disable_edit">
                  {{ getNormalDate(props.item.properties.modified) }}
                </span>
                <span v-if="!disable_edit">
                  {{ getNormalDate(Date.now()) }}
                </span>
              </td>
            </tr>
            <tr>
              <td>Comments</td>
              <td>
                <v-textarea
                  ref="permanentposts_comments"
                  v-model="props.item.properties.comments"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  @click.stop="
                    methodEditPatrolPermanentpostsGeoJson({
                      post_num: $refs.permanentposts_postnum.value,
                      condition: $refs.permanentposts_condition.value,
                      purpose: $refs.permanentposts_purpose.value,
                      sign: $refs.permanentposts_sign.value,
                      sign_type: $refs.permanentposts_signtype.value,
                      rope: $refs.permanentposts_rope.value,
                      source: $refs.permanentposts_source.value,
                      comments: $refs.permanentposts_comments.value,
                      edit_by: computedAuth.profile.email
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('patrol', 'permanentposts', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              methodDeleteSignshopSignageGeoJson();
              confirm_delete = false;
              disable_edit = true;
              methodToggleSingleLayer('patrol', 'permanentposts', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
.content {
  max-height: 100%;
  max-width: 100%;
  padding: 0px !important;
  display: inline-block;
}
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      confirm_delete: false,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      disable_edit: true,
      opt_rope: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ],
      opt_source: [
        { text: "CAD-GPS" },
        { text: "Phone" },
        { text: "Eye Ball" },
        { text: "Unknown" }
      ],
      opt_condition: [
        { text: "Good Condition" },
        { text: "Good Condition/ But Short" },
        { text: "Poor Condition/ Needs Replacement" },
        { text: "Buried" },
        { text: "Remove" },
        { text: "Miscellaneous" },
        { text: "Proposed" },
        { text: "Unknown" }
      ],
      opt_purpose: [
        { text: "Avalanche Closure" },
        { text: "Boundary" },
        { text: "Cliff" },
        { text: "Permanent Closure" },
        { text: "Gate" },
        { text: "Information Sign" },
        { text: "Unknown" }
      ],
      opt_sign: [
        {
          text: "Yes",
          value: "yes"
        },
        {
          text: "No",
          value: "no"
        },
        {
          text: "Unknown",
          value: ""
        }
      ]
    };
  },
  computed: {
    computedSignline() {
      if (this.computedPatrolPermanentpostsVisibility) {
        const permanentposts = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = permanentposts.filter(
          item => item.properties.id == this.computedPatrolPermanentpostsId
        );
        return result[0].properties.sign_line;
      }
      return [];
    },
    computedPostnum() {
      if (this.computedPatrolPermanentpostsVisibility) {
        const permanentposts = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = permanentposts.filter(
          item => item.properties.id == this.computedPatrolPermanentpostsId
        );
        return result[0].properties.post_num;
      }
      return [];
    },
    computedPatrolPermanentpostsGeoJsonFeature() {
      if (
        this.$store.state.mapLayers.patrol.layers.permanentposts.geojson
          .features
      ) {
        const permanentposts = this.$store.state.mapLayers.patrol.layers
          .permanentposts.geojson.features;
        const result = permanentposts.filter(
          item => item.properties.id == this.computedPatrolPermanentpostsId
        );
        return result;
      }
      return [];
    },
    computedPatrolPermanentpostsVisibility() {
      return this.$store.state.mapLayers.patrol.layers.permanentposts.visibility
        .singleView;
    },
    computedPatrolPermanentpostsLoading() {
      return this.$store.state.mapLayers.patrol.layers.permanentposts.loading;
    },
    computedPatrolPermanentpostsId() {
      return this.$store.state.mapLayers.patrol.layers.permanentposts.visibility
        .singleId;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodDeleteSignshopSignageGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/patrol/permanentposts/" +
            this.computedPatrolPermanentpostsId,
          dept: "patrol",
          layer: "permanentposts",
          token: this.computedAuthToken
        })
        .then(() => {
          this.methodGetPatrolPermanentpostsGeoJson();
        });
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetPatrolPermanentpostsGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/patrol/permanentposts",
        dept: "patrol",
        layer: "permanentposts",
        token: this.computedAuthToken
      });
    },
    methodEditPatrolPermanentpostsGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/patrol/permanentposts/" +
          this.computedPatrolPermanentpostsId,
        dept: "",
        layer: "permanentposts",
        token: this.computedAuthToken,
        payload: data
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.patrol.layers.permanentposts.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetPatrolPermanentpostsGeoJson();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.patrol.layers.permanentposts.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
